import moment from 'moment-timezone'
import React, {Fragment} from 'react'
import SecondaryMenuItems from './SecondaryMenuItems'
import MainMenuItems from './MainMenuItems'
import useBoolState from 'bundles/admin/hooks/useBoolState'

export default ({children}) => {
  const [mobileMenuIsOpen, setMobileMenuIsOpen, toggleMobileMenuIsOpen] = useBoolState(false)
  return (
    <Fragment>
      <header className={mobileMenuIsOpen ? '' : 'close'}>
        <div className='main-menu'>
          <div className='container'>
            <a id='burger' className={mobileMenuIsOpen ? 'close' : ''} onClick={toggleMobileMenuIsOpen}>
              <span></span>
            </a>
            <a href='/' id='logo-small'>
              <span>BAYSIC</span>
            </a>
            <ul className='horizontal'>
              <MainMenuItems onSelect={() => setMobileMenuIsOpen(false)} />
            </ul>
          </div>
        </div>

        <div className='secondary-menu'>
          <div className='container'>
            <ul className='horizontal'>
              <SecondaryMenuItems onSelect={() => setMobileMenuIsOpen(false)} />
            </ul>
          </div>
        </div>
      </header>

      <nav className={`mobile-menu ${mobileMenuIsOpen ? 'open' : ''}`}>
        <ul>
          <SecondaryMenuItems onSelect={() => setMobileMenuIsOpen(false)} />
        </ul>
        <ul>
          <MainMenuItems onSelect={() => setMobileMenuIsOpen(false)} />
        </ul>
      </nav>

      <main className='with-secondary-menu'>{children}</main>

      <footer>
        <section className='section'>
          <div className='container'>
            <span>&#169; BAYSIC {moment().year()}</span>
          </div>
        </section>
      </footer>
    </Fragment>
  )
}
